export const getYoutubeUrl: (videoId: string) => string = (videoId) =>
  `https://www.youtube.com/watch?v=${videoId}`;
